import firebase from "firebase";

const config = {
    apiKey: "AIzaSyCrXqUF1Y5x3lEbix8Nbou0sWJ1OLnjpSM",
    authDomain: "expensetracker-27fbd.firebaseapp.com",
    projectId: "expensetracker-27fbd",
    storageBucket: "expensetracker-27fbd.appspot.com",
    messagingSenderId: "701333700818",
    appId: "1:701333700818:web:f1f30e331d888f72496d0b",
    measurementId: "G-7BE3J8SND3"
};

const fire = firebase.initializeApp(config);
export default fire;